// extracted by mini-css-extract-plugin
export var shake = "_o-0";